import { MappedClass, MappedProperty, MappedPropertyDate } from '@h5s/util-object';
import { DateTime } from 'luxon';

@MappedClass()
export class AstatDailyMovement {
  @MappedPropertyDate()
  date: DateTime;

  @MappedProperty()
  occupiedUnits: number;

  @MappedProperty()
  open: boolean;

  @MappedProperty()
  totalArrivals: number;

  @MappedProperty()
  totalDepartures: number;

  @MappedProperty()
  totalGuestsPresent: number;
}
